import { Box, FlexBox, Text } from '@dixa/lib-shared-habla';
import { WrappedFieldProps } from 'redux-form';

import { ThemeColor } from '../../../../../types';

import { ColorOption } from './ColorOption';

interface Props extends WrappedFieldProps {
  options: ThemeColor[];
}

export function ColorOptions({ options, input, meta }: Props): JSX.Element {
  return (
    <Box>
      <FlexBox alignItems="center" gap="300">
        {options.map(({ id, title, presentationColor }) => (
          <ColorOption
            color={presentationColor}
            title={title}
            key={id}
            onClick={() => input.onChange(id)}
            isSelected={input.value === id}
          />
        ))}
      </FlexBox>

      {meta.error && meta.touched && (
        <Text.Paragraph color="red">{meta.error}</Text.Paragraph>
      )}
    </Box>
  );
}
